import { VEHICLES, type Vehicle } from '../lib/vehicles'
import { useTexte } from '../texte'
import { VehicleIcon } from './VehicleIcon'

/**
 * The vehicles as a row of buttons (#90, 1.96.0), nine since 1.136.0;
 * the row wraps on a phone.
 *
 * **One row for two places**: the sections of a recording on the map
 * (`SectionsSheet`) and the sections of a day before the day card goes out
 * (`Tagwahl`). Decided: the vehicle can be changed when splitting or at the
 * latest when the card is made -- two doors to the same choice, and written
 * twice they would offer different vehicles one day.
 */
export function VehiclePicker({
  value,
  label,
  disabled = false,
  onPick,
}: {
  value: Vehicle
  label: string
  disabled?: boolean
  onPick: (vehicle: Vehicle) => void
}) {
  const t = useTexte().karte.sections
  return (
    <span className="sections__picker" role="radiogroup" aria-label={label}>
      {VEHICLES.map((v) => (
        <button
          key={v}
          type="button"
          role="radio"
          aria-checked={value === v}
          aria-label={t.vehicle[v]}
          title={t.vehicle[v]}
          className={value === v ? 'vehicle-button vehicle-button--chosen' : 'vehicle-button'}
          disabled={disabled}
          data-vehicle-pick={v}
          onClick={() => onPick(v)}
        >
          <VehicleIcon vehicle={v} size={20} />
        </button>
      ))}
    </span>
  )
}
